import { useState } from "react";
import { ReactComponent as EyeIcon } from "../../../assets/icons/fi-eye.svg";
import { ReactComponent as EyeSlash } from "../../../assets/icons/eye-slash.svg";

const InputField = ({
  label,
  type,
  name,
  placeholder,
  IconComponent,
  value,
  onChange,
  toggleVisibility,
  showPassword,
  error,
  iconColor,
  onFocus,
  onBlur,
}) => {
  const [isReadOnly, setIsReadOnly] = useState(true);

  return (
    <div className="flex flex-col space-y-2">
      <label
        htmlFor={name}
        className="text-[14px] font-sf-medium text-[#1C1A3C]"
      >
        {label}
      </label>
      <div className="relative">
        <input
          type={type}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onFocus={(e) => {
            setIsReadOnly(false);
            if (onFocus) onFocus(e);
          }}
          onBlur={(e) => {
            setIsReadOnly(true);
            if (onBlur) onBlur(e);
          }}
          readOnly={isReadOnly}
          autoComplete="off"
          className={`w-full px-4 pl-10 py-3 border ${
            error ? "border-red-500" : "border-gray-300"
          } rounded-lg focus:outline-none focus:ring-2 ${
            error ? "focus:ring-red-500" : "focus:ring-blue-500"
          }`}
          required
        />
        <span className="absolute left-3 top-3 mt-0.5 text-gray-400">
          <IconComponent color={error ? "red" : iconColor} />
        </span>
        {toggleVisibility && (
          <span
            className="absolute right-3 top-3 mt-0.5 text-gray-400 cursor-pointer"
            onClick={toggleVisibility}
            aria-label="Toggle password visibility"
          >
            {showPassword ? (
              <EyeIcon color={error ? "red" : iconColor} />
            ) : (
              <EyeSlash color={error ? "red" : iconColor} />
            )}
          </span>
        )}
      </div>
      {error && <span className="text-red-500 text-sm">{error}</span>}
    </div>
  );
};

export default InputField;
